// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__2Yyri","paymentContainer":"PaymentPage_paymentContainer__2z5j0"};